// src/data/cpdData.js

export const cpdCategories = [
  {
    name: "Educational Activities",
    examples: "Conferences, workshops, seminars, accredited online courses, structured training programs."
  },
  {
    name: "Self-Directed Learning",
    examples: "Reading journal articles, textbooks, guidelines, listening to podcasts, online research."
  },
  {
    name: "Reviewing & Reflecting on Practice",
    examples: "Case reviews, peer review sessions, reflective journaling."
  },
  {
    name: "Measuring Outcomes & Quality Improvement",
    examples: "Clinical audits, patient outcome reviews, quality and safety projects."
  },
  {
    name: "Teaching, Training & Supervising",
    examples: "Teaching students, supervising trainees, developing educational resources."
  },
  {
    name: "Professional Development & Skills",
    examples: "Leadership courses, communication training, ethics and law sessions."
  },
  {
    name: "Research & Scholarship",
    examples: "Conducting or presenting research, publishing articles, attending journal clubs."
  },
  {
    name: "Technology & Innovation",
    examples: "Training on new treatment technologies, digital health tools, AI in medicine."
  },
  {
    name: "Wellbeing & Resilience",
    examples: "Burnout prevention workshops, mindfulness and resilience courses, professional coaching."
  },
  {
    name: "Other / Unclassified",
    examples: "Activities not easily fitting elsewhere but relevant to scope of practice."
  },
];